import { render, staticRenderFns } from "./CervicalCancer.vue?vue&type=template&id=5eac7099&"
import script from "./CervicalCancer.vue?vue&type=script&lang=js&"
export * from "./CervicalCancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports